export const translations = {
  en: {
    nav: { philosophy: "Philosophy", services: "Services", offers: "Offers", gifts: "Gifts", team: "Team", reviews: "Reviews", book: "Book", visit: "Visit", call: "Call" },
    announcements: [
      "Grand Opening — First Month 50% Off",
      "Ladies' Special — Complimentary Head Massage",
      "Free Body Treatment with a Head & Foot Massage",
      "Open Daily 9:30 AM – 10:00 PM",
    ],
    hero: {
      eyebrow: "A private pause in Lakewood, Colorado",
      line1: "Breathe deeper.",
      line2: "Feel lighter.",
      sub: "Step into a quiet, comfortable setting designed for unhurried relaxation — thoughtful massage, clear pricing and a calm atmosphere.",
      call: "Call",
      explore: "Explore Services",
      scroll: "Scroll",
    },
    arrival: {
      hint: "Scroll to enter",
      chapters: [
        { label: "01 — The Street", title: "It begins on an ordinary street." },
        { label: "02 — The Door", title: "One door between you and quiet." },
        { label: "03 — The Lounge", title: "Settle in, softly." },
        { label: "04 — The Room", title: "Your room is already warm." },
        { label: "05 — The Stillness", title: "Now, let everything go." },
      ],
    },
    marquee: ["Relax", "Restore", "Renew", "Breathe", "Unwind", "Stillness"],
    philosophy: {
      label: "About Elite SPA",
      title: { pre: "A composed space for rest, ", it: "stillness", post: " and renewal." },
      body: "Elite SPA is designed around the comfort of slowing down. Soft lighting, clean surroundings and an unhurried atmosphere create a private retreat where the pace of the day can begin to settle.",
      pillars: [
        { title: "Quiet by Design", text: "A peaceful environment helps you disconnect from daily noise and settle into a slower rhythm." },
        { title: "Clean & Considered", text: "Every detail is arranged to support a comfortable, orderly and reassuring visit." },
        { title: "Private Atmosphere", text: "The setting is intentionally calm and discreet, giving you space to rest without feeling rushed." },
      ],
    },
    experience: {
      label: "The Elite Experience",
      title: { pre: "Thoughtful from the first breath to the ", it: "final pause.", post: "" },
      steps: [
        { title: "Calm Arrival", text: "Arrive a few minutes early, settle in and allow the pace of the day to soften before your session begins." },
        { title: "Private Space", text: "A quiet treatment environment supports comfort, discretion and uninterrupted time to rest." },
        { title: "Mindful Details", text: "Session length, pressure preferences and areas of focus can be discussed before getting comfortable." },
        { title: "Restful Finish", text: "Take a quiet moment after your session before returning to the rest of your day." },
      ],
      note: "Please share your preferred session, desired pressure and areas of focus when calling, so your visit can be arranged around your comfort.",
    },
    services: {
      label: "Services & Pricing",
      title: { pre: "Choose the pace ", it: "your body", post: " needs." },
      note: "Contact the spa directly to confirm availability and arrange your preferred time. Gift certificates available.",
      from: "from",
      minutes: "Minutes",
      wellSuited: "Well suited for",
      theExperience: "The experience",
      callToBook: "Call to Book",
      items: {
        "deep-tissue": { tag: "Focused Pressure", name: "Deep Tissue Massage", description: "A concentrated massage style using deliberate pressure across areas that feel especially tight or overworked. Pressure preferences can be discussed before the session.", suitedFor: "Desk-related tightness, active routines and areas needing focused attention.", experience: "Steady, purposeful bodywork with time to focus on priority areas." },
        "swedish-hot-stone": { tag: "Flowing Warmth", name: "Swedish Massage with Hot Stone", description: "Smooth, flowing massage movements paired with gentle warmth for a slower, deeply calming experience created around relaxation and comfort.", suitedFor: "Full-body fatigue, first-time guests and anyone seeking a quiet reset.", experience: "Gentle flow, comforting warmth and an unhurried full-body rhythm." },
        custom: { tag: "Feet & Body", name: "Custom Massage", description: "A flexible session customized around your needs on the feet and body. Share the areas you would like prioritized and the pressure level that feels most comfortable.", suitedFor: "Guests wanting time divided between the feet, body and selected priority areas.", experience: "A personalized balance shaped around comfort and the time available." },
        foot: { tag: "Reflexology & Renewal", name: "Foot Massage", description: "Foot reflexology-inspired attention for feet that feel tired after long days, travel or extended time standing. Steady, therapeutic pressure applied to reflex points helps the whole body let go.", suitedFor: "Long workdays, frequent standing, travel and everyday foot fatigue.", experience: "Concentrated foot massage with a steady, restful pace." },
        head: { tag: "Scalp & Crown", name: "Head Massage", description: "A deeply calming head and scalp massage that melts away the tension carried in the crown, temples and neck. Pair it with a foot massage and receive a complimentary body treatment.", suitedFor: "Screen fatigue, tension headaches and stress held in the scalp, temples and neck.", experience: "Slow, rhythmic scalp work with quiet, restorative pauses." },
      },
      addons: {
        label: "Enhancements",
        title: "Add-Ons",
        italic: "— free hot stone included",
        note: "Every add-on comes with a complimentary hot stone treatment.",
        items: ["Essential Oil", "Scalp Massage · 10 mins", "Scalp Massage · 15 mins", "Cupping"],
      },
    },
    rituals: {
      label: "Signature Focus",
      title: { pre: "The art of ", it: "head & foot.", post: "" },
      intro: "Our deepest focus rests at the crown and the sole — care for the head and feet that lets the whole body settle.",
      head: {
        title: "The Head Ritual",
        text: "A slow, layered ritual for the scalp, temples and crown — where the day's tension gathers first.",
        steps: ["Warm towel & settling breath", "Scalp, temple & crown work", "Neck release & quiet pause"],
      },
      foot: {
        title: "The Foot Ritual",
        text: "Reflexology-inspired care for tired feet — steady pressure on the points that carry you all day.",
        steps: ["Warm welcome & unwinding", "Reflexology-inspired pressure", "Rest & renewed lightness"],
      },
      ladies: {
        tag: "Ladies' Special",
        title: "Head massage, on us.",
        text: "For a limited time, ladies receive a complimentary head massage — call to confirm details and availability.",
        cta: "Call to Claim",
      },
    },
    offers: {
      label: "Current Offers",
      title: { pre: "A generous welcome, ", it: "on the house.", post: "" },
      cards: [
        { tag: "Grand Opening", title: "First Month 50% Off", text: "Celebrate our opening — every service is half price during our first month. Call to confirm your session and lock in the grand opening rate." },
        { tag: "Ladies' Special", title: "Complimentary Head Massage", text: "For a limited time, women guests receive a complimentary head massage. Call to confirm details and availability." },
        { tag: "Signature Pairing", title: "Free Body Treatment", text: "Book a head massage and a foot massage together and receive a complimentary body treatment — the full Elite ritual." },
        { tag: "With Every Add-On", title: "Free Hot Stone", text: "Enhance any session with essential oil, scalp massage or cupping — every add-on includes a complimentary hot stone treatment." },
      ],
      cta: "Call to Claim an Offer",
      note: "Offers confirmed by phone · availability may vary",
    },
    gifts: {
      label: "Give Wellness",
      title: { pre: "The quietest gift you can ", it: "give.", post: "" },
      body: "Share an unhurried pause with someone who needs it. Elite SPA gift certificates can be arranged for any service — from a focused foot session to a full two-hour escape.",
      perks: ["Redeemable for any service or session length", "A thoughtful gesture for birthdays, holidays and thank-yous", "Arranged in minutes with a single phone call"],
      badge: "Gift Certificates Available",
      cta: "Call to Gift",
    },
    atmosphere: {
      label: "Atmosphere",
      title: { pre: "Warm light, quiet details and room to ", it: "exhale.", post: "" },
      body: "A restful experience begins with the setting: composed, clean and intentionally removed from the rush outside.",
    },
    team: {
      label: "The Practice",
      title: { pre: "Practiced hands, ", it: "quiet presence.", post: "" },
      intro: "An experienced team of licensed therapists — matched to your needs on the day you visit.",
      cards: [
        { specialty: "Deep Tissue & Hot Stone", title: "Strength with intention", text: "Steady, deliberate pressure for the places that work hardest — shaped around your comfort." },
        { specialty: "Head & Scalp Rituals", title: "Calm from the crown", text: "Slow, rhythmic scalp work that releases the tension gathered between head and neck." },
        { specialty: "Foot Reflexology", title: "Grounded & renewed", text: "Attentive care for tired feet that lets the whole body feel light again." },
      ],
    },
    reviews: {
      label: "Guest Impressions",
      title: { pre: "A quiet experience people ", it: "remember.", post: "" },
    },
    review: {
      title: "Enjoyed your quiet pause?",
      text: "A short Google review helps neighbors in Lakewood find their way to a calmer day — it takes less than a minute.",
      cta: "Leave a Google Review",
    },
    menu: {
      title: "Service Menu",
      subtitle: "Massage & Relaxation · Lakewood, Colorado",
      addonsTitle: "Add-Ons",
      addonsNote: "Complimentary hot stone with every add-on",
      giftNote: "Gift certificates available",
      tipsNote: "All tips are greatly appreciated",
      print: "Print Menu",
      back: "Back to Website",
    },
    faq: {
      label: "Before You Visit",
      title: { pre: "Quiet ", it: "answers", post: " to common questions." },
      items: [
        { q: "How early should I arrive?", a: "Arriving approximately 10 minutes early is recommended so you have time to settle in, discuss your preferences and begin your visit without feeling rushed." },
        { q: "Can I get a massage if I have an injury?", a: "Please speak with an appropriate healthcare professional before receiving massage when you have a recent injury, ongoing pain, medical condition or recovery restrictions. Contact Elite SPA in advance and explain any relevant concerns so the visit can be discussed. Massage services are not a substitute for medical diagnosis or treatment." },
        { q: "What is your cancellation policy?", a: "Please call Elite SPA directly for the current cancellation policy. When plans change, contacting the spa as early as possible helps make scheduling adjustments easier." },
        { q: "Is there parking available?", a: "Parking conditions can change. Please call before your visit for the latest parking guidance near the 1399 Kipling Street location." },
      ],
    },
    booking: {
      label: "Reserve Your Pause",
      title: { pre: "Request a session, ", it: "unhurried.", post: "" },
      body: "Share your preferred service, date and time and we'll be in touch shortly. If a text is easier, you can send one straight after you submit.",
      preferTalk: "Prefer to talk?",
      name: "Full Name", namePh: "Your name",
      phone: "Phone", phonePh: "(___) ___-____",
      email: "Email (optional)", emailPh: "you@example.com",
      service: "Service", servicePh: "Choose a service",
      date: "Preferred Date", datePh: "Pick a date",
      time: "Preferred Time", timePh: "Choose a time",
      notes: "Notes (optional)", notesPh: "Pressure preference, areas of focus, add-ons…",
      submit: "Request My Session", sending: "Sending…",
      missing: "Please fill in your name, phone, service, date and time.",
      fail: "Something went wrong. Please call us instead —",
      successTitle: "Request sent.",
      successText: "We've got your details and will be in touch shortly.",
      successNudge: "Want a quicker reply? Tap below — your booking details are already written out, just hit send.",
      smsBtn: "Send as text",
      callPrefix: "Or call:",
      another: "Submit another request",
      smsBody: (f) => `Hi Elite SPA, this is ${f.name}. I'd like to book ${f.service} on ${f.date} at ${f.time}.${f.email ? " Email: " + f.email : ""}${f.notes ? " Notes: " + f.notes : ""}`,
    },
    contact: {
      label: "Contact & Location",
      title: { pre: "Your quiet pause is ", it: "close by.", post: "" },
      body: "Contact Elite SPA by phone to ask about availability, services, session lengths, add-ons or gift certificates.",
      visit: "Visit", call: "Call", hours: "Hours",
      hoursValue: "Open Daily · 9:30 AM – 10:00 PM",
      giftCerts: "Gift Certificates", available: "Available",
      callNow: "Call Now", directions: "Get Directions",
      googleMaps: "Open in Google Maps", appleMaps: "Open in Apple Maps",
      mapHint: "Tap the map for directions",
      note: "Please confirm availability, policies and parking guidance by phone before your visit. Gratuity is appreciated.",
    },
    footer: {
      tagline: "Massage & relaxation in a quiet, private setting in Lakewood, Colorado.",
      hours: "Open Daily · 9:30 AM – 10:00 PM",
      rights: "All rights reserved.",
      promo: "Grand Opening — First Month 50% Off",
    },
    veil: {
      welcome: "Welcome",
      title: "An unhurried escape awaits.",
      hint: "Soft guzheng ambience · low volume",
      enter: "Enter Elite Spa",
      withSound: "Enter with Ambience",
      silence: "Enter in Silence",
    },
    gate: { preparing: "Preparing your escape" },
    sound: { ambience: "Ambience", on: "Ambience On", volume: "Volume" },
  },

  zh: {
    nav: { philosophy: "理念", services: "项目", offers: "优惠", gifts: "礼卡", team: "团队", reviews: "评价", book: "预约", visit: "到访", call: "致电" },
    announcements: [
      "盛大开业 — 首月五折",
      "女士专享 — 免费头部按摩",
      "预订头部+足部按摩,赠全身护理",
      "每日营业 9:30 – 22:00",
    ],
    hero: {
      eyebrow: "科罗拉多州莱克伍德的静谧一隅",
      line1: "深呼吸。",
      line2: "更轻盈。",
      sub: "步入安静舒适的空间,享受从容的放松时光——用心的按摩、透明的价格与宁静的氛围。",
      call: "致电",
      explore: "探索项目",
      scroll: "下滑",
    },
    arrival: {
      hint: "滑动 · 步入其中",
      chapters: [
        { label: "01 — 街角", title: "一切,始于一条寻常的街。" },
        { label: "02 — 门扉", title: "一扇门,隔开喧嚣与宁静。" },
        { label: "03 — 静候区", title: "落座片刻,渐入安宁。" },
        { label: "04 — 房间", title: "属于你的房间,已然温暖。" },
        { label: "05 — 静谧", title: "此刻,放下一切。" },
      ],
    },
    marquee: ["放松", "修护", "焕新", "呼吸", "舒缓", "静谧"],
    philosophy: {
      label: "关于 Elite SPA",
      title: { pre: "沉静之境,休憩、", it: "静谧", post: "与焕新之所。" },
      body: "Elite SPA 以「慢下来」为设计初心。柔和的灯光、洁净的环境与从容的氛围,构筑一处私密的休憩之所,让一天的节奏渐渐沉静。",
      pillars: [
        { title: "静谧为本", text: "宁静的环境帮助您远离日常喧嚣,进入更舒缓的节奏。" },
        { title: "洁净周到", text: "每一处细节皆为舒适、有序与安心的到访体验而设。" },
        { title: "私密氛围", text: "环境刻意保持宁静与私密,让您安心休憩,不被打扰。" },
      ],
    },
    experience: {
      label: "Elite 体验",
      title: { pre: "从第一次呼吸到", it: "最后的静谧", post: ",处处用心。" },
      steps: [
        { title: "从容抵达", text: "提前几分钟到达,安顿身心,让一天的节奏在护理开始前慢慢柔和。" },
        { title: "私密空间", text: "安静的护理环境,给予舒适、私密与不受打扰的休憩时光。" },
        { title: "贴心细节", text: "护理时长、力度偏好与重点部位,可在开始前充分沟通。" },
        { title: "静谧收尾", text: "护理结束后,静享片刻,再回到一天的生活。" },
      ],
      note: "致电时请告知您想要的项目、力度偏好与重点部位,我们将为您妥善安排。",
    },
    services: {
      label: "项目与价格",
      title: { pre: "选择", it: "身体所需", post: "的节奏。" },
      note: "请直接致电确认档期并预约您方便的时间。礼品卡有售。",
      from: "低至",
      minutes: "分钟",
      wellSuited: "适合人群",
      theExperience: "体验感受",
      callToBook: "致电预约",
      items: {
        "deep-tissue": { tag: "深度施压", name: "深层组织按摩", description: "以沉稳而有针对性的力度,深入放松格外紧绷、劳损的部位。力度偏好可在护理前沟通。", suitedFor: "久坐紧绷、运动人群及需要重点放松的部位。", experience: "沉稳有力的手法,针对重点部位充分照护。" },
        "swedish-hot-stone": { tag: "温热流动", name: "瑞典式热石按摩", description: "流畅舒缓的按摩手法配合温热热石,带来更缓慢、深度放松的体验,专为舒适与放松而设。", suitedFor: "全身疲惫、初次体验者及想要安静重启的您。", experience: "轻柔流畅、温暖舒适的全身节奏。" },
        custom: { tag: "足部与全身", name: "定制按摩", description: "根据您的需求灵活定制足部与身体的护理,请告知想要侧重的部位与舒适的力度。", suitedFor: "希望兼顾足部、身体与重点部位的宾客。", experience: "依据您的舒适度与时间,私人定制的平衡之选。" },
        foot: { tag: "足底反射 · 焕活", name: "足部按摩", description: "以足底反射理念,细致照护久站、旅途或漫长一天后的疲惫双足,让全身随之放松。", suitedFor: "长时间工作、久站、旅途及日常足部疲劳。", experience: "专注的足部按摩,节奏沉稳舒缓。" },
        head: { tag: "头皮与颈肩", name: "头部按摩", description: "深度舒缓的头部与头皮按摩,化解累积于头顶、太阳穴与颈部的紧张。搭配足部按摩,更赠全身护理。", suitedFor: "屏幕疲劳、紧张性头痛及头颈部压力人群。", experience: "缓慢而有韵律的头皮手法,伴以静谧的停顿。" },
      },
      addons: {
        label: "升级体验",
        title: "加购项目",
        italic: "— 免费赠送热石",
        note: "每项加购均赠送热石体验。",
        items: ["精油", "头皮按摩 · 10分钟", "头皮按摩 · 15分钟", "拔罐"],
      },
    },
    rituals: {
      label: "招牌之选",
      title: { pre: "", it: "头足之道", post: ",养身之本。" },
      intro: "我们的用心,始于头顶,达于足底——头足兼养,身心自安。",
      head: {
        title: "头部仪式",
        text: "为头皮、太阳穴与头顶而设的缓慢层进式护理——一天的紧张,最先积聚于此。",
        steps: ["热毛巾与安定呼吸", "头皮、太阳穴与头顶按摩", "颈部放松与静谧停顿"],
      },
      foot: {
        title: "足部仪式",
        text: "以足底反射理念呵护疲惫双足——沉稳的按压,照护支撑您一整天的每一处。",
        steps: ["温暖迎宾 · 放松身心", "足底反射式按压", "休憩片刻 · 步履轻盈"],
      },
      ladies: {
        tag: "女士专享",
        title: "头部按摩,免费体验。",
        text: "限时优惠:女士宾客可免费体验头部按摩。详情与名额请致电确认。",
        cta: "致电领取",
      },
    },
    offers: {
      label: "当前优惠",
      title: { pre: "以心相赠,", it: "开业献礼", post: "。" },
      cards: [
        { tag: "盛大开业", title: "首月五折", text: "开业同庆——首月所有项目一律五折。请致电确认档期,锁定开业价格。" },
        { tag: "女士专享", title: "免费头部按摩", text: "限时优惠:女士宾客可免费体验头部按摩。详情与名额请致电确认。" },
        { tag: "招牌搭配", title: "赠全身护理", text: "同时预订头部与足部按摩,即赠一次全身护理——完整体验 Elite 仪式。" },
        { tag: "加购即赠", title: "免费热石", text: "任意加购精油、头皮按摩或拔罐,均赠送热石体验。" },
      ],
      cta: "致电领取优惠",
      note: "优惠以电话确认为准 · 名额有限",
    },
    gifts: {
      label: "心意之礼",
      title: { pre: "最静谧的", it: "心意", post: "。" },
      body: "把一段从容的休憩时光,送给需要它的人。Elite SPA 礼品卡适用于任意项目——从足部护理到两小时的完整体验。",
      perks: ["适用于任意项目与时长", "生日、节日与致谢的贴心之选", "一通电话,即刻备好"],
      badge: "礼品卡有售",
      cta: "致电订购礼卡",
    },
    atmosphere: {
      label: "氛围",
      title: { pre: "暖光、静谧细节,与", it: "呼吸的余地", post: "。" },
      body: "美好的休憩体验,始于环境:沉静、洁净,远离外界的匆忙。",
    },
    team: {
      label: "匠心团队",
      title: { pre: "娴熟之手,", it: "静谧相伴", post: "。" },
      intro: "由资深持证按摩师组成的团队,依您到访当日的需求悉心安排。",
      cards: [
        { specialty: "深层组织与热石", title: "沉稳有度", text: "以沉稳而克制的力度,照护最辛劳的部位——一切以您的舒适为先。" },
        { specialty: "头部与头皮仪式", title: "自顶而静", text: "缓慢而有韵律的头皮手法,释放头颈之间累积的压力。" },
        { specialty: "足底反射", title: "步履轻盈", text: "细致的足部照护,让全身重获轻盈。" },
      ],
    },
    reviews: {
      label: "宾客心声",
      title: { pre: "令人", it: "难忘", post: "的静谧体验。" },
    },
    review: {
      title: "享受了这段静谧时光?",
      text: "一条简短的 Google 评价,能帮助更多莱克伍德的邻居找到属于自己的放松时刻——只需不到一分钟。",
      cta: "留下 Google 评价",
    },
    menu: {
      title: "项目价目表",
      subtitle: "按摩与休憩 · 科罗拉多州莱克伍德",
      addonsTitle: "加购项目",
      addonsNote: "每项加购均赠送热石体验",
      giftNote: "礼品卡有售",
      tipsNote: "感谢您的小费致意",
      print: "打印菜单",
      back: "返回网站",
    },
    faq: {
      label: "到访须知",
      title: { pre: "常见问题的", it: "静心解答", post: "。" },
      items: [
        { q: "需要提前多久到达?", a: "建议提前约 10 分钟到达,以便安顿身心、沟通偏好,从容开始您的护理。" },
        { q: "受伤后可以按摩吗?", a: "如有近期受伤、持续疼痛、疾病或恢复期限制,请先咨询专业医护人员,并提前致电说明相关情况。按摩不能替代医学诊断或治疗。" },
        { q: "取消政策是怎样的?", a: "请直接致电了解最新取消政策。若计划有变,请尽早联系,以便我们为您调整安排。" },
        { q: "有停车位吗?", a: "停车情况可能变动,来访前请致电了解 Kipling 街 1399 号附近的最新停车指引。" },
      ],
    },
    booking: {
      label: "预约您的静谧时光",
      title: { pre: "从容", it: "预约", post: "一次护理。" },
      body: "留下您想要的项目、日期与时间,我们会尽快与您联系。若发短信更方便,提交后即可一键发送。",
      preferTalk: "更想直接通话?",
      name: "姓名", namePh: "您的姓名",
      phone: "手机号码", phonePh: "(___) ___-____",
      email: "邮箱（选填）", emailPh: "you@example.com",
      service: "项目", servicePh: "选择项目",
      date: "期望日期", datePh: "选择日期",
      time: "期望时间", timePh: "选择时间",
      notes: "备注(选填)", notesPh: "力度偏好、重点部位、加购项目……",
      submit: "提交预约申请", sending: "提交中…",
      missing: "请填写姓名、电话、项目、日期与时间。",
      fail: "提交失败,请直接致电 —",
      successTitle: "预约已提交。",
      successText: "我们已收到您的信息,会尽快与您联系。",
      successNudge: "想更快得到回复?点击下方 — 预约信息已为您写好,发送即可。",
      smsBtn: "发送短信",
      callPrefix: "或致电:",
      another: "再提交一个预约",
      smsBody: (f) => `您好 Elite SPA,我是${f.name}。想预约${f.service},时间:${f.date} ${f.time}。${f.email ? "邮箱:" + f.email : ""}${f.notes ? "备注:" + f.notes : ""}`,
    },
    contact: {
      label: "联系与位置",
      title: { pre: "静谧时光,", it: "近在咫尺", post: "。" },
      body: "欢迎致电 Elite SPA,咨询档期、项目、时长、加购或礼品卡。",
      visit: "到访", call: "致电", hours: "营业时间",
      hoursValue: "每日营业 · 9:30 – 22:00",
      giftCerts: "礼品卡", available: "有售",
      callNow: "立即致电", directions: "获取路线",
      googleMaps: "在 Google 地图中打开", appleMaps: "在 Apple 地图中打开",
      mapHint: "点击地图获取路线",
      note: "到访前请致电确认档期、政策与停车指引。感谢您的小费致意。",
    },
    footer: {
      tagline: "科罗拉多州莱克伍德,静谧私密的按摩与休憩之所。",
      hours: "每日营业 · 9:30 – 22:00",
      rights: "版权所有。",
      promo: "盛大开业 — 首月五折",
    },
    veil: {
      welcome: "欢迎",
      title: "一场从容的休憩,静候您来。",
      hint: "古筝轻音 · 轻声",
      enter: "进入 Elite Spa",
      withSound: "伴乐入内",
      silence: "静音进入",
    },
    gate: { preparing: "静候您的到来" },
    sound: { ambience: "氛围音", on: "氛围音 · 开", volume: "音量" },
  },

  es: {
    nav: { philosophy: "Filosofía", services: "Servicios", offers: "Ofertas", gifts: "Regalos", team: "Equipo", reviews: "Reseñas", book: "Reservar", visit: "Visita", call: "Llamar" },
    announcements: [
      "Gran Apertura — 50% el Primer Mes",
      "Especial para Damas — Masaje de Cabeza de Cortesía",
      "Tratamiento Corporal Gratis con Masaje de Cabeza y Pies",
      "Abierto a Diario 9:30 AM – 10:00 PM",
    ],
    hero: {
      eyebrow: "Una pausa privada en Lakewood, Colorado",
      line1: "Respira profundo.",
      line2: "Siéntete ligero.",
      sub: "Entra en un espacio tranquilo y cómodo diseñado para una relajación sin prisas: masajes cuidadosos, precios claros y un ambiente sereno.",
      call: "Llamar",
      explore: "Ver Servicios",
      scroll: "Desliza",
    },
    arrival: {
      hint: "Desliza para entrar",
      chapters: [
        { label: "01 — La Calle", title: "Comienza en una calle cualquiera." },
        { label: "02 — La Puerta", title: "Una puerta entre tú y la calma." },
        { label: "03 — La Sala de Espera", title: "Acomódate, suavemente." },
        { label: "04 — La Sala", title: "Tu sala ya está cálida." },
        { label: "05 — La Quietud", title: "Ahora, suéltalo todo." },
      ],
    },
    marquee: ["Relájate", "Restaura", "Renueva", "Respira", "Descansa", "Serenidad"],
    philosophy: {
      label: "Sobre Elite SPA",
      title: { pre: "Un espacio sereno para el descanso, la ", it: "quietud", post: " y la renovación." },
      body: "Elite SPA está diseñado en torno al placer de bajar el ritmo. Luz suave, entornos impecables y una atmósfera sin prisas crean un refugio privado donde el pulso del día comienza a calmarse.",
      pillars: [
        { title: "Silencio por Diseño", text: "Un entorno apacible te ayuda a desconectar del ruido diario y entrar en un ritmo más lento." },
        { title: "Limpio y Cuidado", text: "Cada detalle está dispuesto para una visita cómoda, ordenada y tranquilizadora." },
        { title: "Ambiente Privado", text: "El entorno es intencionalmente sereno y discreto, dándote espacio para descansar sin prisa." },
      ],
    },
    experience: {
      label: "La Experiencia Elite",
      title: { pre: "Cuidado desde el primer respiro hasta la ", it: "pausa final.", post: "" },
      steps: [
        { title: "Llegada Serena", text: "Llega unos minutos antes, acomódate y deja que el ritmo del día se suavice antes de tu sesión." },
        { title: "Espacio Privado", text: "Un entorno de tratamiento silencioso brinda comodidad, discreción y descanso sin interrupciones." },
        { title: "Detalles Conscientes", text: "La duración, la presión preferida y las zonas de enfoque se conversan antes de comenzar." },
        { title: "Final Reparador", text: "Tómate un momento de calma después de tu sesión antes de volver a tu día." },
      ],
      note: "Al llamar, comparte tu sesión preferida, la presión deseada y las zonas de enfoque para organizar tu visita a tu medida.",
    },
    services: {
      label: "Servicios y Precios",
      title: { pre: "Elige el ritmo que ", it: "tu cuerpo", post: " necesita." },
      note: "Contacta al spa directamente para confirmar disponibilidad y acordar tu horario. Tarjetas de regalo disponibles.",
      from: "desde",
      minutes: "minutos",
      wellSuited: "Ideal para",
      theExperience: "La experiencia",
      callToBook: "Llama para Reservar",
      items: {
        "deep-tissue": { tag: "Presión Focalizada", name: "Masaje de Tejido Profundo", description: "Un estilo de masaje concentrado con presión deliberada en las zonas más tensas o sobrecargadas. La presión se conversa antes de la sesión.", suitedFor: "Tensión de oficina, rutinas activas y zonas que requieren atención focalizada.", experience: "Trabajo corporal firme y con propósito, con tiempo para las zonas prioritarias." },
        "swedish-hot-stone": { tag: "Calidez Fluida", name: "Masaje Sueco con Piedras Calientes", description: "Movimientos suaves y fluidos acompañados de una calidez delicada, para una experiencia más lenta y profundamente calmante.", suitedFor: "Fatiga corporal, primeras visitas y quien busque un reinicio tranquilo.", experience: "Fluidez suave, calidez reconfortante y un ritmo corporal sin prisas." },
        custom: { tag: "Pies y Cuerpo", name: "Masaje Personalizado", description: "Una sesión flexible adaptada a tus necesidades en pies y cuerpo. Indica las zonas prioritarias y el nivel de presión más cómodo.", suitedFor: "Huéspedes que desean dividir el tiempo entre pies, cuerpo y zonas elegidas.", experience: "Un equilibrio personalizado según tu comodidad y el tiempo disponible." },
        foot: { tag: "Reflexología y Renovación", name: "Masaje de Pies", description: "Cuidado inspirado en la reflexología para pies cansados tras largas jornadas, viajes o mucho tiempo de pie. Presión firme y terapéutica que relaja todo el cuerpo.", suitedFor: "Jornadas largas, estar de pie con frecuencia, viajes y fatiga diaria.", experience: "Masaje de pies concentrado con un ritmo constante y reparador." },
        head: { tag: "Cuero Cabelludo y Coronilla", name: "Masaje de Cabeza", description: "Un masaje de cabeza profundamente calmante que disuelve la tensión de la coronilla, las sienes y el cuello. Combínalo con un masaje de pies y recibe un tratamiento corporal de cortesía.", suitedFor: "Fatiga por pantallas, dolores de cabeza tensionales y estrés en cabeza y cuello.", experience: "Trabajo lento y rítmico del cuero cabelludo, con pausas reparadoras." },
      },
      addons: {
        label: "Extras",
        title: "Complementos",
        italic: "— piedras calientes gratis",
        note: "Cada complemento incluye un tratamiento de piedras calientes de cortesía.",
        items: ["Aceite Esencial", "Masaje de Cuero Cabelludo · 10 min", "Masaje de Cuero Cabelludo · 15 min", "Ventosas"],
      },
    },
    rituals: {
      label: "Enfoque Insignia",
      title: { pre: "El arte de ", it: "cabeza y pies.", post: "" },
      intro: "Nuestro mayor cuidado va de la coronilla a la planta del pie — atención a la cabeza y los pies que calma todo el cuerpo.",
      head: {
        title: "El Ritual de Cabeza",
        text: "Un ritual lento y en capas para el cuero cabelludo, las sienes y la coronilla — donde primero se acumula la tensión del día.",
        steps: ["Toalla tibia y respiración serena", "Cuero cabelludo, sienes y coronilla", "Liberación del cuello y pausa tranquila"],
      },
      foot: {
        title: "El Ritual de Pies",
        text: "Cuidado inspirado en la reflexología para pies cansados — presión firme en los puntos que te sostienen todo el día.",
        steps: ["Bienvenida cálida y relajación", "Presión inspirada en reflexología", "Descanso y ligereza renovada"],
      },
      ladies: {
        tag: "Especial para Damas",
        title: "Masaje de cabeza, cortesía nuestra.",
        text: "Por tiempo limitado, las damas reciben un masaje de cabeza de cortesía — llama para confirmar detalles y disponibilidad.",
        cta: "Llama para Reclamar",
      },
    },
    offers: {
      label: "Ofertas Actuales",
      title: { pre: "Una bienvenida generosa, ", it: "por cuenta de la casa.", post: "" },
      cards: [
        { tag: "Gran Apertura", title: "50% el Primer Mes", text: "Celebra nuestra apertura: todos los servicios a mitad de precio durante el primer mes. Llama para confirmar tu sesión." },
        { tag: "Especial para Damas", title: "Masaje de Cabeza de Cortesía", text: "Por tiempo limitado, las damas reciben un masaje de cabeza de cortesía. Llama para confirmar detalles y disponibilidad." },
        { tag: "Combinación Insignia", title: "Tratamiento Corporal Gratis", text: "Reserva un masaje de cabeza y uno de pies juntos y recibe un tratamiento corporal de cortesía — el ritual Elite completo." },
        { tag: "Con Cada Complemento", title: "Piedras Calientes Gratis", text: "Mejora cualquier sesión con aceite esencial, masaje de cuero cabelludo o ventosas — cada complemento incluye piedras calientes de cortesía." },
      ],
      cta: "Llama para Reclamar una Oferta",
      note: "Ofertas confirmadas por teléfono · sujetas a disponibilidad",
    },
    gifts: {
      label: "Regala Bienestar",
      title: { pre: "El regalo más sereno que puedes ", it: "dar.", post: "" },
      body: "Comparte una pausa sin prisas con quien la necesite. Las tarjetas de regalo de Elite SPA se pueden preparar para cualquier servicio — desde una sesión de pies hasta un escape completo de dos horas.",
      perks: ["Canjeable por cualquier servicio o duración", "Un gesto atento para cumpleaños, fiestas y agradecimientos", "Lista en minutos con una sola llamada"],
      badge: "Tarjetas de Regalo Disponibles",
      cta: "Llama para Regalar",
    },
    atmosphere: {
      label: "Ambiente",
      title: { pre: "Luz cálida, detalles serenos y espacio para ", it: "exhalar.", post: "" },
      body: "Una experiencia reparadora comienza con el entorno: sereno, impecable e intencionalmente alejado del ajetreo exterior.",
    },
    team: {
      label: "Nuestra Práctica",
      title: { pre: "Manos expertas, ", it: "presencia serena.", post: "" },
      intro: "Un equipo experimentado de terapeutas certificados — asignados según tus necesidades el día de tu visita.",
      cards: [
        { specialty: "Tejido Profundo y Piedras Calientes", title: "Fuerza con intención", text: "Presión firme y deliberada para las zonas que más trabajan — siempre a tu medida." },
        { specialty: "Rituales de Cabeza", title: "Calma desde la coronilla", text: "Trabajo lento y rítmico del cuero cabelludo que libera la tensión entre cabeza y cuello." },
        { specialty: "Reflexología Podal", title: "Renovado desde los pies", text: "Cuidado atento para pies cansados que devuelve la ligereza a todo el cuerpo." },
      ],
    },
    reviews: {
      label: "Impresiones de Huéspedes",
      title: { pre: "Una experiencia serena que se ", it: "recuerda.", post: "" },
    },
    review: {
      title: "¿Disfrutaste tu pausa serena?",
      text: "Una breve reseña en Google ayuda a más vecinos de Lakewood a encontrar su momento de calma — toma menos de un minuto.",
      cta: "Dejar una Reseña en Google",
    },
    menu: {
      title: "Menú de Servicios",
      subtitle: "Masajes y Relajación · Lakewood, Colorado",
      addonsTitle: "Complementos",
      addonsNote: "Piedras calientes de cortesía con cada complemento",
      giftNote: "Tarjetas de regalo disponibles",
      tipsNote: "Todas las propinas son muy apreciadas",
      print: "Imprimir Menú",
      back: "Volver al Sitio",
    },
    faq: {
      label: "Antes de Tu Visita",
      title: { pre: "Respuestas ", it: "serenas", post: " a preguntas comunes." },
      items: [
        { q: "¿Con cuánta anticipación debo llegar?", a: "Se recomienda llegar unos 10 minutos antes para acomodarte, conversar tus preferencias y comenzar tu visita sin prisa." },
        { q: "¿Puedo recibir un masaje si tengo una lesión?", a: "Consulta con un profesional de la salud antes de recibir un masaje si tienes una lesión reciente, dolor persistente, una condición médica o restricciones de recuperación. Contacta a Elite SPA con antelación para conversar tu visita. Los masajes no sustituyen el diagnóstico ni el tratamiento médico." },
        { q: "¿Cuál es la política de cancelación?", a: "Llama directamente a Elite SPA para conocer la política de cancelación vigente. Si tus planes cambian, avisar lo antes posible facilita los ajustes de agenda." },
        { q: "¿Hay estacionamiento disponible?", a: "Las condiciones de estacionamiento pueden cambiar. Llama antes de tu visita para conocer la orientación más reciente cerca de 1399 Kipling Street." },
      ],
    },
    booking: {
      label: "Reserva Tu Pausa",
      title: { pre: "Solicita una sesión, ", it: "sin prisas.", post: "" },
      body: "Comparte tu servicio, fecha y hora preferidos y te responderemos en breve. Si te resulta más cómodo un mensaje de texto, puedes mandarlo justo después.",
      preferTalk: "¿Prefieres hablar?",
      name: "Nombre Completo", namePh: "Tu nombre",
      phone: "Teléfono", phonePh: "(___) ___-____",
      email: "Correo (opcional)", emailPh: "tu@ejemplo.com",
      service: "Servicio", servicePh: "Elige un servicio",
      date: "Fecha Preferida", datePh: "Elige una fecha",
      time: "Hora Preferida", timePh: "Elige una hora",
      notes: "Notas (opcional)", notesPh: "Presión preferida, zonas de enfoque, complementos…",
      submit: "Solicitar Mi Sesión", sending: "Enviando…",
      missing: "Por favor completa nombre, teléfono, servicio, fecha y hora.",
      fail: "Algo salió mal. Por favor llámanos —",
      successTitle: "Solicitud enviada.",
      successText: "Tenemos tus datos y nos pondremos en contacto en breve.",
      successNudge: "¿Quieres una respuesta más rápida? Toca abajo — los datos de tu reserva ya están escritos, solo envía.",
      smsBtn: "Enviar como SMS",
      callPrefix: "O llama:",
      another: "Enviar otra solicitud",
      smsBody: (f) => `Hola Elite SPA, soy ${f.name}. Quisiera reservar ${f.service} el ${f.date} a las ${f.time}.${f.email ? " Correo: " + f.email : ""}${f.notes ? " Notas: " + f.notes : ""}`,
    },
    contact: {
      label: "Contacto y Ubicación",
      title: { pre: "Tu pausa serena está ", it: "muy cerca.", post: "" },
      body: "Llama a Elite SPA para consultar disponibilidad, servicios, duraciones, complementos o tarjetas de regalo.",
      visit: "Visita", call: "Llama", hours: "Horario",
      hoursValue: "Abierto a Diario · 9:30 AM – 10:00 PM",
      giftCerts: "Tarjetas de Regalo", available: "Disponibles",
      callNow: "Llamar Ahora", directions: "Cómo Llegar",
      googleMaps: "Abrir en Google Maps", appleMaps: "Abrir en Apple Maps",
      mapHint: "Toca el mapa para indicaciones",
      note: "Confirma disponibilidad, políticas y estacionamiento por teléfono antes de tu visita. La propina es apreciada.",
    },
    footer: {
      tagline: "Masajes y relajación en un entorno tranquilo y privado en Lakewood, Colorado.",
      hours: "Abierto a Diario · 9:30 AM – 10:00 PM",
      rights: "Todos los derechos reservados.",
      promo: "Gran Apertura — 50% el Primer Mes",
    },
    veil: {
      welcome: "Bienvenido",
      title: "Un escape sin prisas te espera.",
      hint: "Suave ambiente de guzheng · a bajo volumen",
      enter: "Entrar a Elite Spa",
      withSound: "Entrar con Ambiente",
      silence: "Entrar en Silencio",
    },
    gate: { preparing: "Preparando tu escape" },
    sound: { ambience: "Ambiente", on: "Ambiente Activo", volume: "Volumen" },
  },
};
